// SideBarLink Elements
import { ChevronDown } from 'react-feather';
import { Link, LinkProps, NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { ThemeInterface } from '../../../theme/ThemeInterface';
import { Span } from '../../../typography';

import Collapse from '../Collapse';

type NavItemWrapperProps = {
  bg?: string;
  isWeb?: boolean;
  open: boolean;
};

type LetterAvatarProps = {
  open: boolean;
};

type StyledCollapseProps = {
  open: boolean;
  //className?: string;
  sidebarOpen: boolean;
  active?: boolean;
};

type StyledLinkProps = LinkProps & {
  to: string;
  open: boolean;
  className: string;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
};

const PseudoStyles = `
  & > div {
  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 5px;
    background-color: #009bda;
    border-top-right-radius: 5px;
  }
  & > svg {
    color: #009bda !important;
    fill: #009bda !important;
  }`;

const RadiusStyles = `
  &:before {
    border-bottom-right-radius: 5px;
    transition: all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }`;

export const Tooltip = styled.div`
  opacity: 0;
  left: 70px;
  display: flex;
  font-size: 13px;
  border-radius: 5px;
  visibility: hidden;
  position: absolute;
  align-items: center;
  justify-content: center;
  transform: translateX(10px);
  background-color: rgba(40, 42, 47, 1);
  & p {
    margin: 0 !important;
    color: white;
    text-transform: uppercase;
  }
  &:after {
    top: 50%;
    width: 0;
    margin: 0;
    height: 0;
    left: -5px;
    content: '';
    line-height: 0;
    position: absolute;
    transform: translateY(-50%);
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 5px solid ${(props: ThemeInterface) => props.theme.colors.primary};
  }
`;

export const NavItemWrapper = styled.div<NavItemWrapperProps>`
  flex: 1;
  height: 50px;
  display: flex;
  position: relative;
  align-self: stretch;
  align-items: center;
  white-space: nowrap;
  background: transparent;
  justify-content: flex-start;
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  & svg {
    stroke: ${props => props.open && !props.isWeb && props.theme.colors.primary};
  }
  &:hover {
    background: ${props => (props.open ? props.theme.colors.transparentBlack : 'transparent')};
  }
  &:hover ${Tooltip} {
    opacity: 1;
    width: auto;
    padding: 10px;
    visibility: visible;
    transform: translateX(0);
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`;

export const StyledLink = styled(Link)<StyledLinkProps>`
  display: flex;
  align-self: stretch;
  text-decoration: none;
  ${props => !props.open && RadiusStyles};
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);

  &.active-nav-link > div ${Span} {
    color: ${(props: ThemeInterface) => props.theme.colors.primary};
  }

  &.active-nav-link ${NavItemWrapper} {
    background-color: ${(props: ThemeInterface) => props.theme.colors.transparentBlack};
  }

  &:hover ${Span} {
    color: ${(props: ThemeInterface) => props.theme.colors.primary};
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  &:hover ${NavItemWrapper} {
    background-color: ${(props: ThemeInterface) => props.theme.colors.transparentBlack};
  }

  .child-link-active {
    ${PseudoStyles};
  }
`;

export const StyledSubMenuLink = styled(NavLink)<any>`
  width: 100%;
  text-decoration: none;
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);

  &:hover {
    background-color: ${(props: ThemeInterface) => props.theme.colors.transparentBlack};
  }

  &:hover ${Span} {
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    color: ${(props: ThemeInterface) => props.theme.colors.white};
  }
`;

export const StyledCollapse = styled(Collapse).attrs({
  suppressClassNameWarning: true,
})<StyledCollapseProps & { allowOverflow?: boolean }>`
  width: 100%;
  position: relative;
  overflow: visible;

  span {
    font-size: 14px !important;
  }

  .nav-item__container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px;
    text-indent: 15%;
    min-height: 50px;
    a {
      width: 100%;
      ${props =>
        !props.open &&
        `
        display: flex;
        justify-content: center;
        `};
    }
  }

  & > svg {
    color: ${props => (props.active ? props.theme.colors.primary : 'white')} !important;
  }
`;

export const StyledExpand = styled(ChevronDown)<any>`
  right: 15px;
  position: absolute;
  opacity: ${props => (props.open ? 1 : 0)};
  visibility: ${props => (props.open ? 'visible' : 'hidden')};
  color: ${(props: ThemeInterface) => props.theme.colors.white};
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) !important;
  transform: ${props => (props.expanded === 'true' ? 'rotateX(180deg)' : 'rotateX(0deg)')};
`;

export const LetterAvatar = styled.div<LetterAvatarProps>`
  height: 100%;
  display: flex;
  position: relative;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  opacity: ${props => (props.open ? 0 : 1)};
  width: ${props => (props.open ? 0 : '100%')};
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  color: ${(props: ThemeInterface) => props.theme.colors.primary};

  &:hover ${Tooltip} {
    opacity: 1;
    width: auto;
    visibility: visible;
    transform: translateX(0);
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`;

export const P = styled.p`
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  color: ${(props: ThemeInterface) => props.theme.colors.white};
`;
